<template>
    <div class="containar">
      <div class="content-title">
        <h2>
          ふきだしコメント欄(右)
        </h2>
        <p>youtubeLIVE・Twitchのコメント欄をLINE風にカスタマイズできます</p>
      </div>
      <div class="contents-block">
      <div class="line__left" v-bind:class="fontStyle" v-bind:style="{color: colors.hex}">
          <div class="line__left-text">
              <div class="text">こんにちは🐟</div>
          </div>
          <div class="line__left-text">
              <div class="text">いい天気ですね</div>
          </div>
      </div>
      <div class="set">
        <h3>フォント選択</h3>
        <select class="select " v-model="fontstyle">
          <optgroup label="--ゴシック--">
            <option value="font1">Zen角ゴシックAntique</option>
            <option value="font4">DotGothic16</option>
            <option value="font7">M PLUS Rounded 1c</option>
            <option value="font6">キウイ丸</option>
          </optgroup>
          <optgroup label="--ポップ--">
            <option value="font2">はちまるポップ</option>
            <option value="font8">ロックンロールOne</option>
          </optgroup>
          <optgroup label="--明朝--">
            <option value="font12">さわらび明朝</option>
            <option value="font13">しっぽり明朝</option>
          </optgroup>
          <optgroup label="--デザイン--">
            <option value="font3">Stick</option>
            <option value="font5">解星デコール</option>
            <option value="font9">佑字【舞】</option>
            <option value="font10">油性マジック</option>
          </optgroup>
        </select>
        <h3>カラー選択</h3>
        <div class="radio-main">
          <chrome-picker :value="colors" v-model="colors"></chrome-picker>
        </div>
        <h3>コピペ用CSS</h3>
        <p>LIVEコメント欄をポップアップ表示→URLをコピー→OBSでブラウザソースを追加し、URLを貼り付け→下記CSSをカスタムCSS欄にコピペ</p>
        <h4>YouTubeLIVEコメント欄のカスタムCSS</h4>
        <div class="radio-main">
          <textarea id="target" readonly class="m-form-text" v-model="resultCSS" />
          <button @click="copy" class="copy-btn">コピー</button>
        </div>
        <h4>Twitchコメント欄のカスタムCSS</h4>
        <div class="radio-main">
          <textarea id="target" readonly class="m-form-text" v-model="twresultCSS" />
          <button @click="copy2" class="copy-btn">コピー</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Chrome} from 'vue-color'
export default {
  name: "app",
  components: {
    'chrome-picker': Chrome,
   },
  data() {
    return {
        fontstyle:'font1',
        colors: {
            hex: '#000000',
            hsl: { h: 150, s: 0, l: 0, a: 1 },
            rgba: { r: 0, g: 0, b: 0, a: 1 },
            a: 1
        },
        data1:'aa',
        importcss:'@import url("https://ruri.info/tool/css/refukidashiComment.css");\nyt-live-chat-text-message-renderer #message,\nyt-live-chat-text-message-renderer #message * {\ncolor:',
        fontcss:'!important;\nfont-family: "Zen Kaku Gothic Antique", sans-serif;}',
        twimportcss:'@import url("https://ruri.info/tool/css/tw-refukidashiComment.css");\n.chat-line__no-background{\ncolor:',
    };
  },
  methods: {
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText(this.importcss + this.colors.hex + this.fontcss)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },
    copy2 () {
      if(navigator.clipboard){
        navigator.clipboard.writeText(this.twimportcss + this.colors.hex + this.fontcss)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },
    setFontCss: function(){
        switch(this.fontstyle){
            case 'font1':
                this.fontcss = '!important;\nfont-family: "Zen Kaku Gothic Antique", sans-serif;}'
                break;
            case 'font2':
                this.fontcss = '!important;\nfont-family: "Hachi Maru Pop", cursive;}'
                break;
            case 'font3':
                this.fontcss = '!important;\nfont-family: "Stick", sans-serif;}'
                break;
            case 'font4':
                this.fontcss = '!important;\nfont-family: "DotGothic16", sans-serif;}'
                break;
            case 'font5':
                this.fontcss = '!important;\nfont-family: "Kaisei Decol", serif;}'
                break;
            case 'font6':
                this.fontcss = '!important;\nfont-family: "Kiwi Maru", serif;}'
                break;
            case 'font7':
                this.fontcss = '!important;\nfont-family: "M PLUS Rounded 1c", sans-serif;}'
                break;
            case 'font8':
                this.fontcss = '!important;\nfont-family: "RocknRoll One", sans-serif;}'
                break;
            case 'font9':
                this.fontcss = '!important;\nfont-family: "Yuji Mai", serif;}'
                break;
            case 'font10':
                this.fontcss = '!important;\nfont-family: "Yusei Magic", sans-serif;}'
                break;
            case 'font12':
                this.fontcss = '!important;\nfont-family: "Sawarabi Mincho", serif;";}'
                break;
            case 'font13':
                this.fontcss = '!important;\nfont-family: "Shippori Mincho", serif;}'
                break;
        }
    }
  },
  watch:{
    fontstyle:function(){
        this.setFontCss()
    },
  },
  computed: {
    resultCSS(){
        return this.importcss + this.colors.hex + this.fontcss;
    },
    twresultCSS(){
        return this.twimportcss + this.colors.hex + this.fontcss;
    },
    fontStyle: function() {
      if (this.fontstyle === 'font1') {
        return 'font1';
      }
      else if (this.fontstyle === 'font2') {
        return 'font2';
      }
      else if (this.fontstyle === 'font3') {
        return 'font3';
      }
      else if (this.fontstyle === 'font4') {
        return 'font4';
      }
      else if (this.fontstyle === 'font5') {
        return 'font5';
      }
      else if (this.fontstyle === 'font6') {
        return 'font6';
      }
      else if (this.fontstyle === 'font7') {
        return 'font7';
      }
      else if (this.fontstyle === 'font8') {
        return 'font8';
      }
      else if (this.fontstyle === 'font9') {
        return 'font9';
      }
      else if (this.fontstyle === 'font10') {
        return 'font10';
      }
      else if (this.fontstyle === 'font12') {
        return 'font12';
      }
      else if (this.fontstyle === 'font13') {
        return 'font13';
      }
      else {
        return '';
      }
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Hachi+Maru+Pop&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Stick&display=swap');
@import url('https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+Antique&display=swap');
@import url('https://fonts.googleapis.com/css2?family=DotGothic16&family=Kaisei+Decol:wght@500&family=Kiwi+Maru:wght@500&family=M+PLUS+Rounded+1c:wght@500&family=RocknRoll+One&family=Sawarabi+Mincho&family=Shippori+Mincho:wght@500&family=Yuji+Mai&family=Yusei+Magic&display=swap');
p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.containar{
  margin: 0 auto;
  max-width: 767px;
}

.content-title{
  text-align: center;
  padding-bottom: 12px;
  margin-top:48px;
  margin-bottom: 48px;
}

h2{
  position: relative;
  display: inline-block;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

h4{
  font-size: 12px;
  margin-top: 24px;
  margin-bottom: 0;
}

.main{
  max-width: 767px;
  margin: 0 auto;
  background-color: #F2F0E9;
}

.contents-block{
  display: -webkit-flex;
	display: flex;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	-webkit-justify-content: space-around;
	justify-content: space-around;
	-webkit-align-items: flex-start;
	align-items: flex-start;
  margin: 24px auto;
  min-width: 0;
}

@media screen and (max-width: 767px) {
  .contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
  }
}
.set{
  padding: 8px 12px 24px 12px;
  background-color: #FFFEF9;
  border-radius: 10px;
  margin-left:12px;
}

/* コメントエリア */
.preview{
    padding: 2px 12px;
}

.line__left{
  text-align: right;
  display: block;
  white-space: nowrap;
  background-color: #ccc;
}

.text {
  margin: 6px 20px;
  padding: 10px 15px;
  position: relative;
  display: inline-block;
  border-radius: 20px;
  background-color: #ffffff;
}

/* 吹き出し */
.text::before {
  content: '';
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  right: -10px;
  top: 10px;
  border-left: 20px solid #ffffff;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}


.select-gradation{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 24px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.select-font{
    font-size: 24px;
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  padding: 12px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.date-off{
  display:none;
}

.font1{
    font-family: 'Zen Kaku Gothic Antique', sans-serif;
}
.font2{
    font-family: 'Hachi Maru Pop', cursive;
}
.font3{
    font-family: 'Stick', sans-serif;
}
.font4{
    font-family: "DotGothic16", sans-serif;
}
.font5{
    font-family: "Kaisei Decol", serif;
}
.font6{
    font-family: "Kiwi Maru", serif;
}
.font7{
    font-family: "M PLUS Rounded 1c", sans-serif;
}
.font8{
    font-family: "RocknRoll One", sans-serif;
}
.font9{
    font-family: "Yuji Mai", serif;
}
.font10{
    font-family: "Yusei Magic", sans-serif;
}
.font12{
    font-family: 'Sawarabi Mincho', serif;
}
.font13{
    font-family: 'Shippori Mincho', serif;
}
.radio-main{
  display: -webkit-flex;
  display: flex;
}
.m-form-text{
    width: 80%;
  height: 76px;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.select{
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
}

.copy-btn{
  background-color: #fff;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
}

.copy-btn:active{
  -webkit-transform: translateY(4px);
  transform: translateY(4px);
  border-bottom: none;
}
</style>